<template>
    <rkm-area
        background-color="warning"
        header-prefix-text="A"
        title="Avaliação - Conduta"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-textarea
                    :validations="validations.descricao"
                    name="Descrição"
                    placeholder="Insira impressões adicionais sobre a avaliação dos problemas/condições detectados."
                    rows="6"
                    v-model="data.model.descricao"
                />
            </rkm-col>
        </rkm-row>

        <BoxProblemaCondicao :data="data" />

        <BoxPreNatal
            v-if="data.additionals.isPrimeiroAtendimentoPreNatal"
            :data="data"
            class="mt-2"
        />

        <BoxEncerramentoGestacao
            v-if="!data.additionals.hasDesfechoGravidezAdicionadoAnteriormente && data.additionals.hasDesfechoGravidez"
            :data="data"
        />

        <BoxAlergia
            :data="alertgiaData"
            class="mt-2"
        />
    </rkm-area>
</template>

<script>
// Components.
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxEncerramentoGestacao from './components/encerramento-gestacao/Index'
import BoxPreNatal from '@/components/ambulatorio/components/pre-natal/Index'
import BoxProblemaCondicao from './components/problema-condicao/Index'

export default {
    components: {
        BoxAlergia,
        BoxEncerramentoGestacao,
        BoxPreNatal,
        BoxProblemaCondicao,
    },
    computed: {
        alertgiaData() {
            return {
                form: {
                    alergiaCriticidades: this.data.form.alergia.criticidades,
                    alergiaTipos: this.data.form.alergia.tipos,
                },
                model: {alergias: this.data.model.alergiasReacoesAdversas},
            }
        },
        validations() {
            return {
                descricao: {max: 5000},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>